import { Component, Input } from '@angular/core';
import { IFAQLibrary } from '../interfaces/faqs.interface';

@Component({
  standalone: false,
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
})
export class FaqsComponent {
  @Input() faqLibrary: IFAQLibrary;
}
